module.exports = __webpack_public_path__ + "static/what-is-devops-6087328bed7a99cad7f61cf18b75a8a8.png";